import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Upgrade = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Upgrade' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,18 L12,8 L12,18 Z M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M17,12 L12,7 L7,12' />
  </StyledIcon>
);
